import { Stack, FlexboxGrid, Col } from 'rsuite';
import classNames from 'classnames';
import { HomeElms, server } from '../config/const';
import { useAppSelector, useAppDispatch } from '@monorepo/shared';
import {
  Brand,
  OUTree,
  NoticeSpeaker,
  UserProfile,
  ServiceDropdown,
  SupportDropdown
} from '@monorepo/shared/components';
import { cloudLog } from '../pages/Home/homeCons';
import { useGetCommonDataQuery } from '@monorepo/shared/services/globalApi';
import {
  isExpanded,
  updateExpanded
} from '@monorepo/shared/store/sidemenuSlice';
import { useLocation } from 'react-router-dom';
import { CSSProperties, useEffect, useState } from 'react';
import { selectNotices } from '@monorepo/shared/store/authSlice';
import {
  selectAccountWithPermission,
  selectLoginSaml
} from '@monorepo/shared/store/accountSlice';
import { selectOU } from '@monorepo/shared/store/fcOuSlice';
import StackItem from 'rsuite/esm/Stack/StackItem';
import ArrowRightIcon from '@rsuite/icons/ArrowRight';
import ArrowLeftIcon from '@rsuite/icons/ArrowLeft';
import { selectHasGroup } from '@monorepo/shared/store/groupSlice';
import './Header.scss';
interface IProps {
  hideSideMenu?: boolean;
  style?: CSSProperties;
}

const Header = ({ hideSideMenu, style }: IProps) => {
  const { pathname } = useLocation();

  const loginSaml = useAppSelector(selectLoginSaml);
  const ouData = useAppSelector(selectOU);
  const notices = useAppSelector(selectNotices);
  const menuExpanded = useAppSelector(isExpanded);
  const hasGroup = useAppSelector(selectHasGroup);
  const account = useAppSelector(selectAccountWithPermission);

  const commonData = useGetCommonDataQuery({
    server
  });

  const dispatch = useAppDispatch();

  const logoClasses = classNames('left-container', {
    expand: menuExpanded
  });

  const logoIcon = (
    <img src={cloudLog} width={30} style={{ marginRight: 2 }} alt="logo" />
  );

  return (
    <div
      className="frame-header"
      style={{
        ...style,
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      {/* LEFT */}
      <div className={logoClasses} style={{ height: '100%' }}>
        <Stack alignItems="center" spacing={60} style={{ height: '100%' }}>
          <Stack alignItems="center" spacing={12} style={{ height: '100%' }}>
            <Brand
              logo={logoIcon}
              title={HomeElms.name}
              isExpanded={menuExpanded}
              subtitle=""
              titleStyle={{
                fontWeight: 500,
                fontSize: '18px'
              }}
              subTitleStyle={{
                fontWeight: 500,
                fontSize: '18px',
                paddingLeft: '4px'
              }}
              width={menuExpanded ? 160 : 48}
            />

            {!hideSideMenu && hasGroup && (
              <div
                style={{
                  cursor: 'pointer',
                  background: 'var(--fsr-space-bg)',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onClick={() => dispatch(updateExpanded(!menuExpanded))}
              >
                {menuExpanded ? (
                  <ArrowLeftIcon fontSize="30px" />
                ) : (
                  <ArrowRightIcon fontSize="30px" />
                )}
              </div>
            )}
          </Stack>

          {account?.portals?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <ServiceDropdown commonData={commonData?.data} account={account} />
          )}

          {account?.support_menu?.some(
            (item: Record<string, any>) => item?.visibility !== 'Hide'
          ) && (
            <SupportDropdown commonData={commonData?.data} account={account} />
          )}
        </Stack>
      </div>

      {/* RIGHT */}
      <Col className="right-container">
        <Stack
          spacing={20}
          justifyContent="flex-end"
          alignItems="center"
          style={{ height: '100%' }}
        >
          <NoticeSpeaker notices={notices} />

          {!pathname.includes('cred') &&
          ouData?.length &&
          account?.permission_scope?.node_type !== 'Account' ? (
            <OUTree hasPermissionScope isNewPortal customClass="fsoc-popup" />
          ) : (
            <></>
          )}

          <UserProfile
            account={account}
            commonData={commonData?.data}
            isNewPortal
            loginSaml={loginSaml}
          />
        </Stack>
      </Col>
    </div>
  );
};

export default Header;
